import { webCrypto } from '#web-crypto';
import { arrayToBase64, stringToArray } from './binary-utils';
export const shaDigest = (data, shaFunction) => webCrypto.subtle.digest(shaFunction, data);
export const sha256 = async (input) => {
    const hash = await shaDigest(stringToArray(input), 'SHA-256');
    return arrayToBase64(hash);
};
export const sha1Bytes = async (input) => {
    return new Uint8Array(await shaDigest(stringToArray(input), 'SHA-1'));
};
